import Main from './TwoFactorAuthenticationMain'

export default { Main }
